module.exports = __webpack_public_path__ + "img/ic-map-add-list-icon.9474791c.svg";